import React from 'react'
import PropTypes from 'prop-types'
import { Provider } from 'react-redux'

import rootReducer from '../reducers'
import configureStore from 'Shared/configureStore'
import VacationsContainer from './VacationsContainer'


const VacationsRoot = ({
  fetchInitialDataURL,
}) => {
  const state = {
    misc: {
      fetchInitialDataURL,
    },
  }

  const store = configureStore(rootReducer, state)

  return <Provider store={ store }><VacationsContainer></VacationsContainer></Provider>
}

VacationsRoot.propTypes = {
  fetchInitialDataURL: PropTypes.string.isRequired,
}

export default VacationsRoot
